import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/logo-genesis-new.svg'


const _hoisted_1 = { class: "bg-gray-lp-100 w-screen h-screen flex items-center justify-center relative" }
const _hoisted_2 = { class: "flex flex-row gap-3 absolute top-6 left-6 items-center" }
const _hoisted_3 = { class: "items-center font-semibold text-base text-black-lp-300" }
const _hoisted_4 = { class: "mr-1" }
const _hoisted_5 = {
  class: "flex flex-col items-center gap-6",
  style: {"width":"480px"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  style: {"width":"184.5px"},
  alt: "logo genesis"
}, null, -1)
const _hoisted_7 = { class: "flex flex-col items-center gap-2 text-center" }
const _hoisted_8 = { class: "font-semibold text-3xl text-black-lp-100" }
const _hoisted_9 = { class: "text-sm text-gray-lp-800" }
const _hoisted_10 = {
  class: "text-sm font-semibold text-gray-lp-800",
  "data-testid": "auth-verify-otp-masked-email"
}
const _hoisted_11 = { class: "flex flex-col gap-3 w-full items-center" }
const _hoisted_12 = { class: "flex flex-row gap-3 justify-center" }
const _hoisted_13 = {
  key: 0,
  class: "text-sm text-red-lp-100 text-center",
  "data-testid": "auth-verify-otp-error"
}
const _hoisted_14 = {
  class: "text-sm text-gray-lp-800 text-center",
  "data-testid": "auth-verify-otp-countdown"
}
const _hoisted_15 = { class: "font-semibold text-black-lp-100" }
const _hoisted_16 = { class: "text-sm text-gray-lp-800 text-center" }
const _hoisted_17 = /*#__PURE__*/_createVNode("a", {
  class: "text-red-lp-100 underline",
  href: "mailto:system@thelionparcel.com"
}, "system@thelionparcel.com", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "text-sm text-gray-lp-800 text-center" }, "@ 2020 All Rights Reserved - Lion Parcel", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _imports_0,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
        class: "w-5 mr-3 cursor-pointer",
        alt: "back"
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.isCountryCodeEmpty ? "Back" : _ctx.$t("Kembali")), 1)
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode("div", _hoisted_7, [
        _createVNode("h1", _hoisted_8, _toDisplayString(_ctx.isCountryCodeEmpty
              ? "Verify OTP code"
              : _ctx.$t("authenticator.verifyOtp.title")), 1),
        _createVNode("p", _hoisted_9, _toDisplayString(_ctx.isCountryCodeEmpty
              ? "Enter the OTP code sent via email to"
              : _ctx.$t("authenticator.verifyOtp.message")), 1),
        _createVNode("p", _hoisted_10, _toDisplayString(_ctx.maskedEmail), 1)
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (i) => {
            return _createVNode("input", {
              key: i,
              ref: 'otpInput' + (i - 1),
              type: "text",
              inputmode: "numeric",
              maxlength: "1",
              class: [
                'w-12 h-12 text-center text-xl font-semibold border rounded-lg outline-none shadow-sm',
                _ctx.hasError
                  ? 'border-red-lp-100 focus:border-red-lp-100'
                  : 'border-gray-lp-400 focus:border-red-lp-100'
              ],
              value: _ctx.otpDigits[i - 1],
              onInput: ($event: any) => (_ctx.onInput($event, i - 1)),
              onKeydown: ($event: any) => (_ctx.onKeyDown($event, i - 1)),
              onPaste: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args))),
              "data-testid": "auth-verify-otp-input"
            }, null, 42, ["value", "onInput", "onKeydown"])
          }), 64))
        ]),
        (_ctx.hasError && _ctx.errorMessage)
          ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_LpButton, {
        title: 
          _ctx.isCountryCodeEmpty
            ? 'Verify'
            : _ctx.$t('authenticator.verifyOtp.verification')
        ,
        isWidthFull: "",
        fontWeight: "semibold",
        disabled: !_ctx.isOtpComplete || _ctx.isLoading,
        onClick: _ctx.verify,
        "data-testid": "auth-verify-otp-button-verify",
        textColor: "white"
      }, null, 8, ["title", "disabled", "onClick"]),
      _createVNode("div", _hoisted_14, [
        (_ctx.countdown > 0)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.isCountryCodeEmpty
              ? "Resend in"
              : _ctx.$t("authenticator.verifyOtp.resendTime")) + " ", 1),
              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.countdownDisplay), 1)
            ], 64))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.isCountryCodeEmpty
              ? "Didn't receive the code?"
              : _ctx.$t("authenticator.verifyOtp.notGetCode")) + " ", 1),
              _createVNode("button", {
                class: "font-semibold text-red-lp-100 hover:underline",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resend && _ctx.resend(...args))),
                disabled: _ctx.isLoading,
                "data-testid": "auth-verify-otp-link-resend"
              }, _toDisplayString(_ctx.isCountryCodeEmpty
                ? "Resend"
                : _ctx.$t("authenticator.verifyOtp.resend")), 9, ["disabled"])
            ], 64))
      ]),
      _createVNode("div", _hoisted_16, [
        _createTextVNode(_toDisplayString(_ctx.isCountryCodeEmpty
            ? "Need help? Contact via WhatsApp"
            : _ctx.$t("authenticator.verifyOtp.helpWhatsApp")) + " ", 1),
        _createVNode("a", {
          class: "text-red-lp-100 underline",
          href: `https://wa.me/${_ctx.cleanPhoneNumber(_ctx.phoneNumberHD)}`,
          target: "_blank"
        }, _toDisplayString(_ctx.phoneNumberHD), 9, ["href"]),
        _createTextVNode(" " + _toDisplayString(_ctx.isCountryCodeEmpty
            ? "or email to"
            : _ctx.$t("authenticator.verifyOtp.orEmailTo")) + " ", 1),
        _hoisted_17
      ]),
      _hoisted_18
    ])
  ]))
}